import BreadCrumb from "components/common/BreadCrumb";
import { Container } from "reactstrap";
import { InvoicesTable } from "./InvoicesTable";
import InvoiceSummaryWidgets from "./InvoiceSummaryWidgets";
import { getDocumentTitle } from "utils/helpers";

const InvoiceList = () => {
  document.title = getDocumentTitle("Invoices");
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Invoices" pageTitle="Finance" />
        <InvoiceSummaryWidgets />
        <InvoicesTable />
      </Container>
    </div>
  );
};

export default InvoiceList;
